import { Component, OnInit, Input } from '@angular/core';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { Router, RouterModule,NavigationEnd } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';


export var authorized = false;
@Component({
  selector: 'app-responsable-blagnac-old',
  templateUrl: './responsable-old.component.html',
  styleUrls: ['./responsable-old.component.scss']
})
export class ResponsableComponentBlagnacOld implements OnInit {
@Output() newItemEvent = new EventEmitter<string>();
  constructor(private http: HttpClient, private list: DataService, private router: Router) {
  
  var messageData;


   messageData = this.list.serviceUpdatedMessage.subscribe({
                next: (messageData) => {
                    console.log(`test j'ai bien recu`, messageData);
                    this.completeData = messageData;
                }
            })
  console.log("messageData", messageData);
  }
@Input() problemTous = "";
@Input() problemSippro = "";
@Input() problemSnef = "";
@Input() problemMairie = "";
@Input() allResponsableInput = "";
@Input() annulerTOUS = "";
completeData:string = "";

poste:string | null = ""
valueButton:string = "";
public value:string = "";
  ngOnInit(): void {
 this.poste = localStorage.getItem('role');
  }

getValue(value:string)
{
this.newItemEvent.emit(value);
console.log("value : ", value);
}

ngOnChanges() {
    this.testButton(this.allResponsableInput);
  }

testButton(value:string)
{
this.valueButton = "TOUS";
this.newItemEvent.emit("TOUS");
}

changeRoute()
{
authorized = true;
}

sendDisplayValue()
  {
  console.log("j'ai cliqué");
  this.list.sendIsConnected()
  this.router.navigate(['/mainBlagnac']);
  }

}


